import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';

@Component({
  selector: 'app-pedido-apelido-modal',
  templateUrl: './pedido-apelido-modal.component.html',
  styleUrls: ['./pedido-apelido-modal.component.scss']
})
export class PedidoApelidoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  idCupom;
  apelido;
  editavel = true;

  public MASKS = MASKS;


  constructor(public dialogRef: MatDialogRef<PedidoApelidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService, private pedidoService: PedidoService, private notificacaoService: NotificacaoService) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
    this.apelido = this.data.apelido;
    this.editavel = this.data.editavel;
  }

  salvar() {

    this.carregandoService.mostra('atualizarApelido');

    this.pedidoService.atualizarApelido(this.idCupom, this.apelido).subscribe(
      (res) => {
        this.carregandoService.esconde('atualizarApelido');
        this.notificacaoService.sucesso('Apelido salva com sucesso!!!');
        this.dialogRef.close(this.apelido);
      },
      (erro) => {
        this.carregandoService.esconde('atualizarApelido');
        this.notificacaoService.erro(erro);
      }
    );


  }

  fechar() {
    this.dialogRef.close();
  }

}
